import { z } from "zod";

/** The language the review, paid feedback and rewritten CV are written in. */
export const reviewLanguageSchema = z.enum(["Indonesian", "English"]);

export type ReviewLanguage = z.infer<typeof reviewLanguageSchema>;

/** Callers that never ask (older drafts, other tools) keep the old default. */
export const DEFAULT_REVIEW_LANGUAGE: ReviewLanguage = "Indonesian";

/** The upload forms preselect the language of the page the person is on. */
export function reviewLanguageForLocale(locale: string): ReviewLanguage {
  return locale === "en" ? "English" : "Indonesian";
}
